import useGlobalSettings from "@components/_hooks/useGlobalSettings";
import { getBrand, money } from "@components/config/helpers";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { useSelector } from "react-redux";

const ProductPriceTypography = ({ type, price, on_offer, original_price, is_poa, buy_price }) => {
    // If poa return fallback
    if (is_poa) return <Typography component="span" className="fw-bold " color={"error"} sx={{ fontSize: 18 }}>Please Call</Typography>

    const { templateSettings } = useSelector((state) => state.globalReducer);
    const has_discount = original_price != price;
    const { getSetting } = useGlobalSettings();
    const colour = getSetting('product_price_colour_variant', 'secondary');
    const displayPurchase = getSetting('purchase_form', 'no') == 'yes';


    return (
        <>
            {(!type || type == 'has_offer' || has_discount) && templateSettings.from_pricing == 'yes' && (
                <Typography component="span" className="fw-bold" color={colour} sx={{ fontSize: 16 }}>
                    From &nbsp;
                </Typography>
            )}
            <Typography component="span" className="fw-bold " color={on_offer ? "error" : colour} sx={{ fontSize: 18, ':hover': { color: `primary.main` } }}>
                {price}
            </Typography>

            {(displayPurchase && buy_price > 0) &&
                <Link href="/purchase">
                    <Button className="cart-add w-100" variant="outlined" size="small">Buy - {money(buy_price)} each</Button>
                </Link>
            }

            {
                templateSettings.suffix_status == 'yes' && (
                    <Typography component="span" className="" color={colour} sx={{ fontSize: 16 }}>
                        {templateSettings.suffix_string}
                    </Typography>
                )
            }
        </>
    )
}

export default ProductPriceTypography